// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "-" + {"4156": "e1b0488e","4884": "728d4391",}[chunkId] + ".css"
}